<template>
  <div v-if="isPending" class="additional-email-readonly-wrapper">
    <atom-text-input :id="`field-${index}`"
                     :model-value="emailAddress"
                     :read-only="true"
                     :label="`Additional Email Address ${index + 1}`"
                     :error-message="validationError"
                     wrapper-width="full"
                     :is-label-visible="false"/>
    <ion-tooltip title="Pending Authorisation">
      <template #visible-content>
        <atom-icon icon="mdi-alert" color="orange" />
      </template>
      <template #tooltip-content>
        <p>
          We've sent a verification email to each new address you've added. To confirm you have access, just follow the instructions in that email.
          If you need to resend the verification, remove the email and add it again.
        </p>
      </template>
    </ion-tooltip>
  </div>
  <template v-else>
    <atom-text-input :id="`field-${index}`"
                     v-model="emailAddress"
                     :label="`Additional Email Address ${index + 1}`"
                     :error-message="validationError"
                     wrapper-width="full"
                     :is-label-visible="false"/>
  </template>
</template>

<script lang="ts">
import type { AdditionalEmail } from "authentication/js/api/user-account.api";
import type { PropType } from "vue";
import AtomIcon from "core/components/atom/icons/AtomIcon.vue";
import AtomTextInput from "core/components/atom/textInput/AtomTextInput.vue";
import IonTooltip from "core/components/ion/tooltip/IonTooltip.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { IonTooltip, AtomIcon, AtomTextInput },
  props: {
    index: { type: Number, required: true },
    additionalEmail: { type: Object as PropType<AdditionalEmail>, default: undefined },
    validationError: { type: String },
  },
  emits: {
    "update:additionalEmail": (_: AdditionalEmail) => true,
  },
  computed: {
    isPending() {
      return this.additionalEmail?.status === "PENDING";
    },
    emailAddress: {
      get() {
        return this.additionalEmail?.emailAddress ?? "";
      },
      set(emailAddress: string) {
        this.$emit("update:additionalEmail", { emailAddress, status: undefined });
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.additional-email-readonly-wrapper {
  display: flex;
  gap: 1em;
}
</style>
